<template>
  <v-container fluid class="px-4" v-if="user_data.profile">
    <v-row justify="center" class="mb-0">
      <h1 class="text-center font-weight-black wemodo-heading-1"><span class="wemodo-purple--text">Ravis de vous revoir.</span>
        <br/><span class="wemodo-fig--text">Choisissez votre parcours.</span>
      </h1>
    </v-row>
    <v-row justify="start" class="mt-0 pt-0 px-4">
      <p class="text-left font-weight-bold wemodo-fig--text wemodo-heading-2">
       <v-icon left class="wemodo-purple--text" large>mdi-book-check</v-icon> Mes Parcours <span class="grey--text font-weight-regular">({{ enrolledCourses.length }})</span>
      </p>
    </v-row>
    <v-row align="center" justify="start">
    <v-col
      v-for="(course, index) in enrolledCourses"
      :key="index"
      md="4"
      cols="12"
    >
      <v-card
        hover
        elevation="0"
        :class="wemodoUniverseAccent1(course.cat)"
        @click="openCourse(course.id)"
        dark
      >
        <v-row class="my-0">
          <v-col>

            <v-card-title class="font-weight-black text-uppercase wemodo-heading-3">
              {{ course.name }}
             
            </v-card-title>
            <v-card-subtitle class="pb-0">
              <v-chip
              small
              outlined
              class="ma-1"
              dark
              style="border: 2px dashed white; text-transform: capitalize;"
            >
              {{ course.cat }}
            </v-chip>
            </v-card-subtitle>
         
          </v-col>
          <v-col cols="3" align-self="center">
            <v-img :src="course.badge_new" width="60"></v-img>
             
          </v-col>
        </v-row>

        <v-container class="py-0 my-0">
          <v-row align="center" class="pa-1 my-1">
          <v-col cols="2">
            <v-avatar :size="35">
              <v-img :src="getCoach(getCourseData(course.id).coach).photo"></v-img>
            </v-avatar>
          </v-col>
          <v-col class="pl-0">
            <span class="caption white--text pb-0">Accompagné par</span>
            <br/>
           <span style="font-size:13px;" class="font-weight-medium">{{`${getCoach(getCourseData(course.id).coach).firstName}`}} {{ `${getCoach(getCourseData(course.id).coach).name}` }}</span>
          </v-col>

 
          <v-col cols="4">
            <v-progress-circular :value=" getCourseValue(course.id)" :size="90" :width="8" dark>
              <strong>{{ getCourseValue(course.id) }}%</strong>
            </v-progress-circular>
          </v-col>
        </v-row>

        <v-row class="my-1 pa-2">
     
            <v-chip small color="transparent" class="mr-2"> <v-icon small left>mdi-clock</v-icon> {{ course.length }}</v-chip>
            <v-chip small color="transparent"> <v-icon small left>mdi-file-document-multiple</v-icon>{{ course.lessons }} leçons</v-chip>
            <v-chip small color="transparent"> <v-icon small left>mdi-certificate</v-icon>{{ course.rs_code }}</v-chip>
      
          
          
        </v-row>

        <!-- <v-row class="px-4 ">
          <span style="font-size:13px;">Progression : <strong>45%</strong></span>
          <v-progress-linear :value="50" :height="10" color="black" striped></v-progress-linear>
        </v-row>
        -->

        <v-card-actions class="my-3">
<!--      
            <v-chip small color="white" rounded>
              <v-icon left small>mdi-account-group</v-icon>
              {{ course.students }} apprenants inscrits
            </v-chip> -->
      
          <v-spacer></v-spacer>
          <v-btn depressed @click="openCourse(course.id)" block :class="wemodoUniverseAccent2(course.cat)">
            Reprendre
            <v-icon right small>mdi-chevron-right</v-icon>
          </v-btn>
        </v-card-actions>
        </v-container>
      </v-card>
    </v-col>
  </v-row>

  <v-row justify="start" class="mt-0 pt-0 px-4">
      <p class="text-left font-weight-bold wemodo-fig--text wemodo-heading-2">
       <v-icon left class="wemodo-fig--text" large>mdi-book-open-variant</v-icon> Nos autres Formations <span class="grey--text font-weight-regular">({{ notEnrolledCourses.length }})</span>
      </p>
    </v-row>

  <v-row align="center" justify="start">
    <v-col
      v-for="(course, index) in notEnrolledCourses"
      :key="index"
      md="4"
      cols="12"
    >
      <v-card
        elevation="1"
        class="pa-4"
        color="white"
        target="_blank"
        :href="course.link"
      >
        <v-row class="mb-2">
          <v-col>
              <div class="badge-promo wemodo-purple--back" v-if="course.cat != 'entrepreneuriat' && course.production == 'final'">-15% ALUMNI 🎓</div>
            <v-card-title class="font-weight-black text-uppercase wemodo-heading-3">
              {{ course.name }}
             
            </v-card-title>
            <v-card-subtitle>
              <v-chip
              small
              outlined
              class="ma-1"
              style="border: 2px dashed black; text-transform: capitalize;"
            >
              {{ course.cat }}
            </v-chip>
            </v-card-subtitle>
         
          </v-col>
          <v-col cols="3" align-self="center">
            <v-img :src="course.badge_new" width="60"></v-img>
          </v-col>
        </v-row>

        <v-row align="center" class="my-0">
          <v-col cols="2">
            <v-avatar :size="35">
              <v-img :src="course.animator.pic"></v-img>
            </v-avatar>
          </v-col>
          <v-col class="pl-0">
            <span class="caption wemodo-fig--text pb-0">Créé par</span>
            <br/>
           <span style="font-size:13px;"> {{ course.animator.name }}</span>
          </v-col>
        </v-row>

        <v-row class="my-0 pa-2">
     
     <v-chip small color="transparent" class="mr-2"> <v-icon small left>mdi-clock</v-icon> {{ course.length }}</v-chip>
     <v-chip small color="transparent"> <v-icon small left>mdi-file-document-multiple</v-icon>{{ course.lessons }} leçons</v-chip>
     <v-chip small color="transparent" v-if="course.rs_code"> <v-icon small left>mdi-certificate</v-icon>{{ course.rs_code }}</v-chip>

   
   
 </v-row>
        <v-card-actions class="my-0 px-0">
     
 
          <v-btn block depressed class="wemodo-purple--back" dark target="_blank" :href="course.link" v-if="course.online">
            En savoir plus
            <v-icon right small>mdi-chevron-right</v-icon>
          </v-btn>
          <v-btn block depressed class="wemodo-purple--back" target="_blank" :href="course.link" v-else>
            Bientôt disponible
            <v-icon right small>mdi-chevron-right</v-icon>
          </v-btn>

        </v-card-actions>

              <div class="promo-box wemodo-pink-50--back wemodo-fig--text" v-if="course.cat != 'entrepreneuriat' && course.production =='final'">
  🎓 Offre Alumni : <strong>-15%</strong> sur ce parcours de formation.<br>
  <em>Profitez-en dès maintenant et rejoignez {{ course.students }} déjà inscrits  !</em>
          </div>

          <div class="promo-box-2" v-else-if="course.cat == 'entrepreneuriat'">
      <em>1 mois d'accompagnement avec un expert en création et gestion d'entreprise (vient en complément d’un parcours de formation) </em>
          </div>

              <div class="promo-box-2" v-if="course.production =='beta'">
      <em>Un programme de formation pilote (bêta) en cours de test qui donnera lieu à une formation complète et certifiante très bientôt !</em>
          </div>

        <!-- <v-divider class="mt-1"></v-divider> -->

        <!-- <v-card-text class="my-0">
           <v-row justify="center" class="mb-0 mt-0">
            <v-col cols="4">
              <v-chip small color="white" rounded>
              <v-icon left small>mdi-account-group</v-icon>
              {{ course.students }} inscrits
            </v-chip>
            </v-col>

             <v-col>
              <span class="black--text">-15% de réduction (offre alumni)</span>
             </v-col>
  
 </v-row>
        </v-card-text> -->
      </v-card>
    </v-col>
  </v-row>

    <!-- <v-row align="center" justify="start">
      <v-col v-for="(course, index) in filteredAndSortedCourses" :key="index" md="3" cols="12">
        <v-card
          min-height="460"
          :class="courseClass(course.cat)"
          style="border:3px solid black !important; border-radius: 0 !important;"
          :disabled="!course.online"
          flat
          :color="cardColor(isEnrolledInCourse(course.id))"
        >
         <v-container class="center-align">
          <v-row justify="center" class="mb-0">
            <v-img :src="course.badge" max-width="200"></v-img>
          </v-row>
          <div class="ribbon ribbon-top-right" v-if="!course.online">
            <span>Bientôt !</span>
          </div>
          <div class="ribbon ribbon-top-right" v-if="course.new">
            <span>New !</span>
          </div>
          <v-row justify="center" class="mb-0 pb-0">
            <v-card-title class="pb-0 font-weight-black">
            {{ course.name }}
          </v-card-title>
          </v-row>
          <v-row justify="center" class="pt-0 mt-0 mb-0 pb-0">
          <v-card-subtitle class="pt-0 font-italic">
            {{ course.title }}
          </v-card-subtitle>
          
        </v-row>

        <v-row justify="center" class="pt-0 mt-0" v-if="!isEnrolledInCourse(course.id) && course.id != 'nTXXUh73MnyqwAidkPwe'">
          <v-chip  small color="#4853FF" dark label>
            <v-icon left small>mdi-sale</v-icon>
            -15% de réduction pour nos élèves !
          </v-chip>
        </v-row> -->

   
   
            <!-- <v-row class="pl-2 mt-0 pt-0">
              <v-rating
                v-model="course.rating.score"
                background-color="white"
                color="yellow accent-4"
                dense
                size="18"
                readonly
                half-increments
              ></v-rating>
              <span class="grey--text text--lighten-2 text-caption ml-2">
                ({{ course.rating.count }})
              </span>
            </v-row> -->
            <!-- <v-row justify="center" class="mt-0" no-gutters>
              <v-col cols="5">
                <v-chip small 
                        outlined
                        label
                        color="black">
                  <v-icon left size="18">mdi-clock</v-icon>
                  {{ course.hours }} heures
                </v-chip>
              </v-col>
              <v-col cols="5">
                <v-chip small
                        outlined
                        label
                        color="black">
                  <v-icon left size="16">mdi-file-document-multiple</v-icon>
                  {{ course.lessons }} leçons
                </v-chip>
              </v-col>
            </v-row>

        </v-container>
          <v-card-actions style="position:absolute;right:0;bottom:0">
            <v-btn
              text
              color="blue accent-4"
              v-if="isEnrolledInCourse(course.id)"
              @click="openCourse(course.id)"
              >Continuer <v-icon right>mdi-chevron-right</v-icon></v-btn
            >
            <v-btn text v-else target="_blank" :href="course.link"
              >En savoir plus <v-icon right>mdi-chevron-right</v-icon></v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row> -->
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { db } from "@/firebase/init";
import firebase  from 'firebase';

export default {
  name: "Welcome",
  data() {
    return {
      hover: false,
      rating: 5,
      loading: false,
    };
  },
  computed: {
    ...mapState(["courses", "user_data", "coaches"]),
    sortedCourses() {
  return [...this.courses].sort(function(a, b) {
    return b.new - a.new;
  });
},
    filteredCourses() {
    return this.sortedCourses.filter(course => this.isNotEnrolledInOldCourse(course.id) && !course.hidden && course.id != 'wHJNNtFUHlMTHGEzS1im');
  },
  enrolledCourses(){
    return this.filteredAndSortedCourses.filter(course => this.isEnrolledInCourse(course.id))
  },
  notEnrolledCourses(){
    return this.filteredAndSortedCourses.filter(course => !this.isEnrolledInCourse(course.id))
  },
  filteredAndSortedCourses() {
    return this.courses
      .filter(course => 
        this.isNotEnrolledInOldCourse(course.id) && 
        !course.hidden && 
        course.id != 'wHJNNtFUHlMTHGEzS1im'
      )
      .sort((a, b) => b.new - a.new);
  },
  },
  methods: {
    getCoach(id){
      return this.coaches.find(coach => coach.id == id)
    },
    getCourseValue(id) {
  const progress = this.getCourseData(id).staticGlobalProgress;

  if (isNaN(progress) || progress === undefined || progress === null) {
    return 0;
  } else {
    return progress;
  }
},
    getCourseData(id){
      let coursesData = this.user_data.coursesSummary;
      let courseData = {}

      courseData = coursesData.filter(el => el.id === id)

      return courseData[0]
    },
    wemodoUniverseAccent1(cat) {
       switch (cat) {
        case 'web':
          return 'wemodo-sky--back';
        case 'creation':
          return 'wemodo-fuschia--back';
        case 'marketing':
          return 'wemodo-tangerine--back';
          case 'data & IA':
          return 'wemodo-purple--back';
          case 'entrepreneuriat':
            return 'wemodo-peacok--back';
        default:
          return 'wemodo-sky--back';
      }
    },
    wemodoUniverseAccent2(cat) {
       switch (cat) {
        case 'web':
          return 'wemodo-sunny--back wemodo-fig--text font-weight-bold';
        case 'creation':
          return 'wemodo-pink-50--back wemodo-fig--text font-weight-bold';
        case 'marketing':
          return 'wemodo-sunny--back wemodo-fig--text font-weight-bold';
          case 'data & IA':
          return 'wemodo-sunny--back wemodo-fig--text font-weight-bold';
          case 'entrepreneuriat':
            return 'wemodo-sunny--back wemodo-fig--text font-weight-bold';
        default:
          return 'wemodo-sunny--back wemodo-fig--text font-weight-bold';
      }
    },
    wemodoUniverseRuban(cat) {
      switch (cat) {
        case 'web':
          return 'wemodo-background-web.svg';
        default:
          return '';
      }
    },
    getBackgroundColor(cat) {
      switch (cat) {
        case 'web':
          return '#DCF8FF';
        case 'creation':
          return '#FBF4FD';
        case 'marketing':
          return '#FDF2D1';
          case 'data & IA':
          return '#ECEAFF';
          case 'entrepreneuriat':
            return '#cfe3fc';
        default:
          return '#ffffff';
      }
    },
    courseColor(cat) {
      switch (cat) {
        case 'web':
          return '#40CBED';
        case 'creation':
          return '#D688EA';
        case 'marketing':
          return '#F9DA74';
          case 'entrepreneuriat':
            return '#3984EA';
        default:
          return '#ffffff';
      }
    },
    courseClass(cat){
      if(cat == 'web'){
        return 'new-ui-card-blue new-ui-card'
      }
      else if(cat == 'marketing'){
        return 'new-ui-card-yellow new-ui-card'
      }
      if(cat == 'creation'){
        return 'new-ui-card-pink new-ui-card'
      }
      if(cat == 'data & IA'){
        return 'new-ui-card-purple new-ui-card'
      }
      if(cat == 'entrepreneuriat'){
        return 'new-ui-card-neutral new-ui-card'
      }
    },
    isNotEnrolledInAcre(id){
      if(id === 'wHJNNtFUHlMTHGEzS1im'){
        if(this.isEnrolledInCourse(id)){
          return true
        }
        else {
          return false
        }
      }
      else {
        return true
      }
    },
    isNotEnrolledInOldCourse(id){
      if(id === 'a0d4QvJlvYY3KufEnk2a'){
        if(this.isEnrolledInCourse(id)){
          return true
        }
        else {
          return false
        }
      }
      else if (id === '9G65qhevCI54B75KtYMq') {
        if(this.isEnrolledInCourse(id)){
          return true
        }
        else {
          return false
        }
      }

      else if (id === 'h1ESAYB8CFPpaXN3I9Zx') {
        if(this.isEnrolledInCourse(id)){
          return true
        }
        else {
          return false
        }
      }
      else {
        return true
      }
    },
    cardColor(bool){
     return bool ? "white" : "grey lighten-5"
    },
    isEnrolledInCourse(course_id) {
      return this.user_data.profile.coursesEnrolled.includes(course_id);
    },
    openCourse(course_id) {
      this.loading = true;


      setTimeout(() => {
        db.collection(`users/${this.user_data.profile.user_id}/courses`).doc(course_id).update({
          loginHistory : firebase.firestore.FieldValue.arrayUnion({
              login: new Date(),
              logout: null,
              sessionLength: null

          })
        }).then(() => {
           this.$store.dispatch("setCourse", course_id).then(() => {
          this.$router.push({
            name: "dashboard",
            params: { course: course_id },
          });
        });
        })
       
      }, 1200);
    },
  },
  async mounted() {
    await this.$store.dispatch("setCourses");
    await this.$store.dispatch("setCoaches");
  },
};
</script>

<style>
.new-ui-card-blue:hover {
  box-shadow: 10px 10px 0px 0px #80dcf3 !important;
}

.new-ui-card-pink:hover {
  box-shadow: 10px 10px 0px 0px #EECDF6 !important;
}

.new-ui-card-yellow:hover {
  box-shadow: 10px 10px 0px 0px #FBE6A2 !important;
}

.new-ui-card-purple:hover {
  box-shadow: 10px 10px 0px 0px #AC94E3 !important;
}

.new-ui-card-neutral:hover {
  box-shadow: 10px 10px 0px 0px #cfe3fc !important;
}


.new-ui-card {
  transition: box-shadow 300ms ease 0ms, background-color 300ms ease 0ms, background-image 300ms ease 0ms !important;
}

.ribbon {
  width: 150px;
  height: 150px;
  overflow: hidden;
  position: absolute;
}
.ribbon::before,
.ribbon::after {
  position: absolute;
  z-index: -1;
  content: "";
  display: block;
  border: 5px solid black;
}
.ribbon span {
  position: absolute;
  display: block;
  width: 225px;
  padding: 15px 0;
  background-color: black;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  color: #fff;
  font: 700 18px/1 "Lato", sans-serif;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  text-transform: uppercase;
  text-align: center;
}

/* top right*/
.ribbon-top-right {
  top: -10px;
  right: -10px;
}
.ribbon-top-right::before,
.ribbon-top-right::after {
  border-top-color: transparent;
  border-right-color: transparent;
}
.ribbon-top-right::before {
  top: 0;
  left: 0;
}
.ribbon-top-right::after {
  bottom: 0;
  right: 0;
}
.ribbon-top-right span {
  left: -25px;
  top: 30px;
  transform: rotate(45deg);
}

.badge-promo {
position: absolute;
top: -10px;
right: -10px;
color: white;
padding: 6px 10px;
font-weight: bold;
border-radius: 6px;
font-size: 14px;
animation: glow 2s infinite alternate;
}

.promo-box {
color: #8c1c13;
padding: 10px;
border-radius: 8px;
margin-top: 10px;
font-size: 14px;
}

.promo-box-2 {
background-color: #eeeffc;
color: #4762b3;
padding: 10px;
border-radius: 8px;
margin-top: 10px;
font-size: 14px;
}
</style>